"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetchModuleInApplication = exports.useModuleUpdate = exports.useModuleCreate = exports.useModuleFetch = void 0;
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const modulesAction_1 = require("./modulesAction");
const AuthGuard_1 = require("../../components/tsComponents/AuthGuard");
function useModuleFetch() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const moduleFetchLoading = (0, react_redux_1.useSelector)((state) => state['modules/fetch'].loading);
    const moduleFetchData = (0, react_redux_1.useSelector)((state) => state['modules/fetch'].data);
    const moduleFetchError = (0, react_redux_1.useSelector)((state) => state['modules/fetch'].error);
    const history = (0, react_router_dom_1.useNavigate)();
    const moduleFetch = (fetchPayload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, modulesAction_1.fetch)(fetchPayload));
    });
    return { moduleFetchLoading, moduleFetchData, moduleFetchError, moduleFetch };
}
exports.useModuleFetch = useModuleFetch;
function useModuleCreate() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const moduleCreateLoading = (0, react_redux_1.useSelector)((state) => state['modules/create'].loading);
    const moduleCreateData = (0, react_redux_1.useSelector)((state) => state['modules/create'].data);
    const moduleCreateError = (0, react_redux_1.useSelector)((state) => state['modules/create'].error);
    const history = (0, react_router_dom_1.useNavigate)();
    const moduleCreate = (createPayload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, modulesAction_1.create)(createPayload));
    });
    return { moduleCreateLoading, moduleCreateData, moduleCreateError, moduleCreate };
}
exports.useModuleCreate = useModuleCreate;
function useModuleUpdate() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const moduleUpdateLoading = (0, react_redux_1.useSelector)((state) => state['modules/update'].loading);
    const moduleUpdateData = (0, react_redux_1.useSelector)((state) => state['modules/update'].data);
    const moduleUpdateError = (0, react_redux_1.useSelector)((state) => state['modules/update'].error);
    const history = (0, react_router_dom_1.useNavigate)();
    const moduleUpdate = (createPayload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, modulesAction_1.update)(createPayload));
    });
    return { moduleUpdateLoading, moduleUpdateData, moduleUpdateError, moduleUpdate };
}
exports.useModuleUpdate = useModuleUpdate;
function useFetchModuleInApplication() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const moduleInApplicationFetchLoading = (0, react_redux_1.useSelector)((state) => state['modules/fetchModulesInApplication'].loading);
    const moduleInApplicationFetchData = (0, react_redux_1.useSelector)((state) => state['modules/fetchModulesInApplication'].data);
    const moduleInApplicationFetchError = (0, react_redux_1.useSelector)((state) => state['modules/fetchModulesInApplication'].error);
    const history = (0, react_router_dom_1.useNavigate)();
    const moduleInApplicationFetch = (fetchPayload) => __awaiter(this, void 0, void 0, function* () {
        let result = yield (0, AuthGuard_1.isLoggedIn)();
        if (!result) {
            history('/auth/sign-in');
            return;
        }
        yield dispatch((0, modulesAction_1.fetchModulesInApplication)(fetchPayload));
    });
    return { moduleInApplicationFetchLoading, moduleInApplicationFetchData, moduleInApplicationFetchError, moduleInApplicationFetch };
}
exports.useFetchModuleInApplication = useFetchModuleInApplication;
